import React, { useState, useEffect } from 'react';
import * as api from '../../api';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Spinner from '../../Plateforme/Atoms/Spinner';
import Section from '../Atoms/Section';
import { useNavigate, useLocation } from 'react-router-dom';
import { createUrlWithRedirect } from '../Utils/redirectUtils';
import { generateFD100KVDataURL } from '../Utils/generateFD100KV';
import { supabase } from '../../lib/supabaseClient'; // Used for fd100_project_names
import FD100KitPage from './FD100KitPage';

const NoProjectsMessage = styled.div`
    text-align: center;
    padding: 40px;
    color: #666;
    font-size: 16px;
    max-width: 600px;
    margin: 0 auto;
`;

// List of winner project IDs from FD10025Winners.js
const WINNER_PROJECT_IDS = [
    '67a332e21b103d938bafb0dc',
    '67a0b8331b103d938bafa954',
    '67aa1011740d844a3d633e93',
    '6829daa5754f51df2ef9141c',
    '67e6c18043d5609350e381a8',
    '67b5e6146890f1a147192905',
    '67be4a58b1ba28c3144aeb73',
    '67bf2330b1ba28c3144af8d2',
    '67c090dcdb48cb16a13c5b43',
    '677268097ec5d90c89d6fe63',
    '67c6b416db48cb16a13c73c7',
    '67ab652c07736060460b3b75',
    '68348986754f51df2ef9b87c',
    '67d15108d95ccf24eaf191df',
    '67d7d38c43d5609350e242a1',
    '67d82d2243d5609350e24c5e',
    '662adc507159e5b1b1da7c75',
    '67d8718c43d5609350e25c38',
    '67d1977243d5609350e218f2',
    '682b5c5f754f51df2ef93bbc',
    '67da910a43d5609350e274d7',
    '67e1864b43d5609350e2baeb',
    '67daebf343d5609350e27a9e',
    '67dd585043d5609350e28e57',
    '67dfeb0e43d5609350e2a360',
    '67e1452a43d5609350e2b066',
    '678675e2de3ed4a7001ab532',
    '67e2d05943d5609350e2cf97',
    '67e3e1cb43d5609350e304e5',
    '67e3e81543d5609350e308de',
    '67e3f02643d5609350e30a0a',
    '67e42d7043d5609350e32539',
    '67e42e5543d5609350e32570',
    '67e45c9843d5609350e329c0',
    '67e529f743d5609350e33a8c',
    '67e53aab43d5609350e340c3',
    '67e56ab043d5609350e3490f',
    '67e5764d43d5609350e34cb5',
    '67e57f5143d5609350e3519a',
    '67e5864c43d5609350e353a3',
    '67e58da443d5609350e3561d',
    '67e58ebc43d5609350e35665',
    '67e5ab6b43d5609350e35905',
    '67e6828d43d5609350e36b6a',
    '67e6acaf43d5609350e37832',
    '67e51ddb43d5609350e33667',
    '67e6c0a843d5609350e380cf',
    '67e6d53a43d5609350e38725',
    '67e6dfff43d5609350e38900',
    '67e7003c43d5609350e38bfc',
    '6834625c754f51df2ef9a4b1',
    '67ea99b76b7945ed1a576bae',
    '67f90250a0262e085d37088f',
    '67e1741a43d5609350e2b608',
    '67fe7a6c9167c049fff4e37e',
    '67ab6ade07736060460b3c16',
    '6810a343264e7745556acae1',
    '6800f4c59167c049fff51f5d',
    '6800b8529167c049fff50e47',
    '6800e76e9167c049fff5197f',
    '6800ef849167c049fff51c6f',
    '6800fad59167c049fff52224',
    '680113739167c049fff52d73',
    '680106139167c049fff525af',
    '680125219167c049fff53405',
    '680957ab9167c049fff5a7c2',
    '681164d36c8fbfe5e3c91e9e',
    '68020ef79167c049fff54015',
    '68025d069167c049fff56132',
    '680b728c9167c049fff5c8f7',
    '680249249167c049fff55a19',
    '68024ed89167c049fff55b90',
    '68025b1a9167c049fff56037',
    '680270379167c049fff566f5',
    '680274c09167c049fff567c8',
    '680275419167c049fff567de',
    '68027b389167c049fff56954',
    '680291609167c049fff56cad',
    '6802a3fc9167c049fff56f5f',
    '6849787b17dde4ca4c4bf043',
    '6849435a17dde4ca4c4be251',
    '6807cb759167c049fff58dd4',
    '6808c3f59167c049fff599c7',
    '6808c3859167c049fff599b1',
    '680fa4b19167c049fff5deee',
    '6801e2f49167c049fff53ce1',
    '680a54a09167c049fff5bbc4',
    '680b94b29167c049fff5cd49',
    '6810df4a264e7745556ad75d',
    '680fa3f89167c049fff5deb1',
    '680fa844a71ddf126b77b977',
    '680fa9f09167c049fff5e027',
    '6810c9b9264e7745556acf4d',
    '681125b66c8fbfe5e3c91c62',
    '6818cac19e656d77bc6c72fa',
    '6818d27e9e656d77bc6c75a3',
    '6818dbdf9e656d77bc6c78a0',
    '682d97b2754f51df2ef96070',
    '67fccffaa0262e085d370ddc',
    '680271809167c049fff5674a'
];

const MyWinningProjects = (props) => {
    const { i18n } = useTranslation('common');
    const [winningProjects, setWinningProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [kvImages, setKvImages] = useState({});
    const [generatingKvs, setGeneratingKvs] = useState(false);
    const [definitiveNames, setDefinitiveNames] = useState({});
    const navigate = useNavigate();
    const location = useLocation();

    const eventId = '67590da5499bcc995c210b40';
    const isAdmin = props.fullUser?.user?.role === 'admin';

    useEffect(() => {
        if (props.fullUserLoading) return;
        if (!props.fullUser?.user) {
            navigate(createUrlWithRedirect('/login', location.pathname));
            return;
        }
        fetchWinningProjects();
    }, [props.fullUserLoading, props.fullUser, navigate]);

    const fetchWinningProjects = async () => {
        try {
            setLoading(true);

            // Fetch definitive project names from Supabase
            const { data: projectNamesData } = await supabase
                .from('fd100_project_names')
                .select('*')
                .eq('event_id', eventId);

            const namesMap = {};
            if (projectNamesData) {
                projectNamesData.forEach(item => {
                    namesMap[item.project_id] = {
                        name_fr: item.name_definitive_fr,
                        name_en: item.name_definitive_en,
                        designer: item.designer_definitive,
                        typology_fr: item.typology_fr,
                        typology_en: item.typology_en
                    };
                });
            }
            setDefinitiveNames(namesMap);

            let matchedProjects = [];

            if (isAdmin) {
                // Targeted fetch: server picks 1 random winner project directly
                const response = await api.getRandomWinnerProjectData({ projectIds: WINNER_PROJECT_IDS, eventId });
                if (response.data) {
                    const { project, user, company, participation } = response.data;
                    matchedProjects = [{ project, user: { user, company }, participation }];
                }
            } else {
                const userParticipations = await api.getUserParticipations({ userid: props.fullUser.user._id });
                const eventParticipation = userParticipations.data.find(p => p.eventId === eventId);

                if (eventParticipation?.data?.projets) {
                    matchedProjects = eventParticipation.data.projets
                        .map(projectId => {
                            let project;
                            if (typeof projectId === 'object' && projectId !== null) {
                                project = projectId;
                            } else {
                                project = props.fullUser.company?.projects?.find(p => p._id === projectId);
                            }
                            if (project && WINNER_PROJECT_IDS.includes(project._id)) {
                                return { project, user: props.fullUser, participation: eventParticipation };
                            }
                            return null;
                        })
                        .filter(Boolean);
                }

                // Fallback: if no winning projects found via user's own participation,
                // check company projects directly (handles collaborators who didn't
                // personally register for FD100 but belong to a winning company)
                if (matchedProjects.length === 0 && props.fullUser.company?.projects) {
                    matchedProjects = props.fullUser.company.projects
                        .filter(p => WINNER_PROJECT_IDS.includes(p._id))
                        .map(project => ({ project, user: props.fullUser, participation: eventParticipation || null }));
                }
            }

            setWinningProjects(matchedProjects);
            setLoading(false);

            // Generate KV images in background (page is already visible)
            if (matchedProjects.length > 0) {
                setGeneratingKvs(true);
                const kvData = {};

                for (const projectData of matchedProjects) {
                    const pid = projectData.project._id;
                    try {
                        const formattedProjectData = {
                            project: projectData.project,
                            user: projectData.user
                        };
                        const definitiveData = namesMap[pid];
                        const editedData = definitiveData ? {
                            projectName: definitiveData.name_fr || definitiveData.name_en,
                            creatorName: definitiveData.designer
                        } : null;

                        const normalDataUrl = await generateFD100KVDataURL(formattedProjectData, false, 'cover', editedData);
                        const invertedDataUrl = await generateFD100KVDataURL(formattedProjectData, true, 'cover', editedData);

                        kvData[pid] = {
                            normal: normalDataUrl,
                            inverted: invertedDataUrl
                        };
                    } catch (err) {
                        console.error(`Error generating KV for project ${pid}:`, err);
                    }
                }
                setKvImages(kvData);
                setGeneratingKvs(false);
            }
        } catch (error) {
            console.error("Error fetching winning projects:", error);
            setLoading(false);
        }
    };

    const downloadKV = (dataUrl, projectName, version) => {
        const link = document.createElement('a');
        link.href = dataUrl;
        link.download = `${projectName}_KeyVisual_${version}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleProjectClick = (projectData) => {
        const { project, user, participation } = projectData;
        const email = user?.user?.email || props.fullUser?.user?.email;
        const pid = participation?._id;
        const projid = project?._id;
        navigate(`/admin/events/fdficheprojet?email=${email}&pid=${pid}&projid=${projid}&mode=jury`);
    };

    if (loading) {
        return (
            <Section className="padding">
                <br/><br/>
                <Spinner />
            </Section>
        );
    }

    if (winningProjects.length === 0) {
        return (
            <Section className="padding">
                <NoProjectsMessage>
                    <p className="thin">
                        {i18n.language === 'fr'
                            ? 'Vous n\'avez pas de projet lauréat pour le moment.'
                            : 'You don\'t have any winning projects at the moment.'}
                    </p>
                </NoProjectsMessage>
            </Section>
        );
    }

    const companyName = props.fullUser?.company?.name;
    const userName = `${props.fullUser?.user?.firstname || ''} ${props.fullUser?.user?.lastname || ''}`.trim();
    const companyLogo = props.fullUser?.company?.logoPath
        ? `${process.env.REACT_APP_MEDIA_BASE_URL}userfiles/${props.fullUser.company.logoPath}`
        : null;

    return (
        <FD100KitPage
            mode="laureat"
            displayName={companyName || userName}
            displayLogo={companyLogo}
            partenaireType={null}
            projects={winningProjects}
            kvImages={kvImages}
            generatingKvs={generatingKvs}
            definitiveNames={definitiveNames}
            eventId={eventId}
            downloadKV={downloadKV}
            onProjectClick={handleProjectClick}
        />
    );
};

export default MyWinningProjects;
